import { render, staticRenderFns } from "./FreeReason.vue?vue&type=template&id=a61c4744&"
import script from "./FreeReason.vue?vue&type=script&lang=js&"
export * from "./FreeReason.vue?vue&type=script&lang=js&"
import style0 from "./FreeReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports